import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import FadeInUp from 'src/utils/FadeInUp';
import ViewMonitor from 'src/utils/ViewMonitor';

export type SectionProps =
    React.HTMLAttributes<HTMLElement> &
    {
        title?: string;
        noTitle?: boolean;
        id: string;
        hasBottomLine: boolean;
    };

const styles = {
    container: {
        ...stylesheet.PaddingGutter(2, directions.bottom)
    },
    bottomLine: {
        display: 'block',
        height: 1,
        width: 0,
        margin: '0 auto',
        backgroundColor: 'black',
        transition: 'width .3s linear',
        backfaceVisibility: 'hidden',
        transform: 'translate3d(0,0,0)',
        ...stylesheet.MarginGutter(2, directions.top)
    },
    bottomLineShow: {
        [responsive.BeforeTablet]: {
            width: `calc(100% - ${spacing.Gutter.Desktop * 1}px)`
        },
        [responsive.AfterTablet]: {
            width: `calc(100% - ${spacing.Gutter.Desktop * 2}px)`
        }
    },
    title: {
        ...stylesheet.Subtitle_1,
        textAlign: 'center',
        ...stylesheet.PaddingGutter(1, directions.sides | directions.bottom)
    }
};

type Props =
    SectionProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {

};
class Section extends React.Component<Props, State> {
    public readonly state: State = {}
    private container: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();

    render() {
        const {
            children,
            classes,
            title,
            appScrollerCtx,
            className,
            noTitle,
            id,
            hasBottomLine,
            ...rest
        } = this.props;

        return (
            <section
                ref={this.container}
                data-section={id}
                {...rest}
                className={classNames(className, classes!.container)}
            >
                <FadeInUp>
                    {title && !noTitle && <h3 className={classes!.title}>{title}</h3>}
                </FadeInUp>
                {children}
                {hasBottomLine && <ViewMonitor>
                    {(isVisible) =>
                        <div className={classNames(classes!.bottomLine, isVisible && classes!.bottomLineShow)} />
                    }
                </ViewMonitor>}
            </section>);
    }
}

export default withStyles(styles)(withAppScroller(Section));


// WEBPACK FOOTER //
// ./src/components/Section.tsx